/**
 * Dashboard - Main dashboard layout component
 * Two products: KPA Ton Concours (info/search) and Boss Ton Concours (quiz/prep)
 */
import React, { useState } from 'react';
import Learn from '../Learn';
import LessonManager from '../LessonManager';
import PaymentManager from '../PaymentManager';
import ConcoursManager from '../pka/ConcoursManager';
import BossAnalytics from './BossAnalytics';
import BossOverview from './BossOverview';
import BossUsers from './BossUsers';
import DatabaseManager from './DatabaseManager';
import KpaAnalytics from './KpaAnalytics';
import KpaCredits from './KpaCredits';
import KpaNotifications from './KpaNotifications';
import KpaOverview from './KpaOverview';
import KpaReferral from './KpaReferral';
import KpaUsers from './KpaUsers';
import Overview from './Overview';
import QuestionGenerator from './QuestionGenerator';
import Settings from './Settings';
import Sidebar, { DashboardSection } from './Sidebar';

interface DashboardProps {
  onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
  const [currentSection, setCurrentSection] = useState<DashboardSection>('overview');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleNavigate = (section: string) => {
    setCurrentSection(section as DashboardSection);
  };

  const renderContent = () => {
    switch (currentSection) {
      // ── Global ──
      case 'overview':
        return <Overview onNavigate={handleNavigate} />;
      case 'settings':
        return <Settings />;

      // ── KPA Ton Concours ──
      case 'kpa-overview':
        return <KpaOverview onNavigate={handleNavigate} />;
      case 'kpa-concours':
        return <ConcoursManager />;
      case 'kpa-users':
        return <KpaUsers />;
      case 'kpa-credits':
        return <KpaCredits />;
      case 'kpa-notifications':
        return <KpaNotifications />;
      case 'kpa-referral':
        return <KpaReferral />;
      case 'kpa-analytics':
        return <KpaAnalytics />;

      // ── Boss Ton Concours ──
      case 'boss-overview':
        return <BossOverview onNavigate={handleNavigate} />;
      case 'learning':
        return <Learn />;
      case 'lesson-manager':
        return <LessonManager />;
      case 'payments':
        return <PaymentManager />;
      case 'questions':
        return <QuestionGenerator />;
      case 'database':
        return <DatabaseManager />;
      case 'boss-users':
        return <BossUsers />;
      case 'boss-analytics':
        return <BossAnalytics />;

      default:
        return <Overview onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar
        currentSection={currentSection}
        onSectionChange={setCurrentSection}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        onLogout={onLogout}
      />
      <main className="flex-1 overflow-auto">
        <div className="p-6">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
